import { api, setToken } from "./client";
import type { Token, UserRead } from "@/types";

export async function login(
  username: string,
  password: string,
): Promise<UserRead> {
  const token = await api.post<Token>("/auth/login", { username, password });
  setToken(token.access_token);
  return api.get<UserRead>("/auth/me");
}

export async function register(
  username: string,
  email: string,
  password: string,
): Promise<UserRead> {
  return api.post<UserRead>("/auth/register", { username, email, password });
}

export function logout(): void {
  // Clear the refresh-token cookie server-side
  fetch("/api/v1/auth/logout", { method: "POST", credentials: "include" }).catch(() => {});
  setToken(null);
  // Clear all cached application data to prevent data leaking between accounts
  // Keep comfyviz_last_user_id (user-switch detection) and comfyviz_lang (i18n preference)
  const lsKeep = new Set(["comfyviz_last_user_id", "comfyviz_lang"]);
  const lsKeysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("comfyviz_") && !lsKeep.has(key)) lsKeysToRemove.push(key);
  }
  lsKeysToRemove.forEach((k) => localStorage.removeItem(k));
  const ssKeysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith("comfyviz_")) ssKeysToRemove.push(key);
  }
  ssKeysToRemove.forEach((k) => sessionStorage.removeItem(k));
}

export function getMe(): Promise<UserRead> {
  return api.get<UserRead>("/auth/me");
}
